import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

class ResourcesService{

    getRisorse(token, codShop){     

        return axios({
            method: 'get',
            url: API_URL + 'risorse/GetRisorse', 
            params:{
                codShop: codShop
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }            
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});            
    }
}

export default new ResourcesService();